import Game from './game';

export { Game };
